export const replaceGroupFinal = (str, groupFinal) =>
  str
    ?.replace('{{bossName}}', groupFinal?.duplicatedValues?.bossName?.toUpperCase())
    ?.replace('{{year}}', groupFinal?.duplicatedValues?.year);

export const replaceResult = (str, bossName, year) => str?.replace('{{bossName}}', bossName?.toUpperCase())?.replace('{{year}}', year);
